import React from 'react';
import { Rocket, Heart, BarChart, DollarSign, Users, Clock, TrendingUp, Shield, Target } from 'lucide-react';

const FranchiseKPIs = () => {
  const kpis = [
    { icon: Rocket, text: 'Faster onboarding and ramp time' },
    { icon: Heart, text: 'Higher customer satisfaction scores' },
    { icon: BarChart, text: 'Greater operational consistency' },
    { icon: DollarSign, text: 'Improved upsell and add-on revenue' },
    { icon: Users, text: 'Lower frontline turnover' },
    { icon: Clock, text: 'Reduced manager coaching time' },
    { icon: TrendingUp, text: 'Higher location-level performance' },
    { icon: Shield, text: 'Fewer brand compliance issues' },
    { icon: Target, text: 'Predictable execution across locations' }
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Traain Delivers the KPIs
          </h2>
          <p className="text-2xl text-cyan-400 font-semibold">
            Franchise Leaders Care About
          </p>
          <p className="text-lg text-gray-400 mt-4">
            Franchise and multi-unit brands using Traain see measurable improvement in:
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {kpis.map((kpi, index) => {
            const Icon = kpi.icon;
            return (
              <div
                key={index}
                className="p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300"
              >
                <Icon className="w-10 h-10 text-cyan-400 mb-4" />
                <p className="text-gray-300">{kpi.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FranchiseKPIs;
